import { css } from '@emotion/css';
import { xocPlate } from 'constants/global.style';
import { useEffect, useRef, useState } from 'react';

interface Props {
    timerCount: string;
    timerFinish: string;
    result: string[] | null;
}
export default function PlateBowXD(props: Props) {
    const { timerCount, result, timerFinish } = props;

    const timerFinishRef = useRef<HTMLDivElement>(null);
    const timerRef = useRef<HTMLDivElement>(null);

    const [showHotTimer, setShowHotTimer] = useState(false);
    const [currentResult, setCurrentResult] = useState<string[]>(['1', '1', '1', '1']);
    const [stateBowl, setStateBolw] = useState<'OPEN' | 'CLOSE' | ''>('OPEN');
    const [statePlate, setStatePlate] = useState<'XOC' | 'STOP'>('STOP');
    const [showTimer, setShowTimer] = useState(false);

    useEffect(() => {
        if (timerFinish) {
            if (timerFinishRef.current) {
                timerFinishRef.current.style.transform = 'scale(1.25)';
                setTimeout(() => {
                    if (timerFinishRef.current) {
                        timerFinishRef.current.style.transform = 'scale(1)';
                    }
                }, 160);
            }
        }
    }, [timerFinish]);

    useEffect(() => {
        setShowHotTimer(Number(timerCount) < 10);
        if (Number(timerCount) < 10 && timerRef.current) {
            timerRef.current.style.transform = 'scale(1.25)';
            setTimeout(() => {
                if (timerRef.current) {
                    timerRef.current.style.transform = 'scale(1)';
                }
            }, 160);
        }
        if (timerCount === '00') {
            setTimeout(() => {
                setShowTimer(false);
            }, 200);
        } else {
            setShowTimer(true);
        }
    }, [timerCount]);

    useEffect(() => {
        if (result) {
            setStateBolw('CLOSE');
            setTimeout(() => {
                setStatePlate('XOC');
                setShowTimer(false);
                setCurrentResult(result);
            }, 300);

            setTimeout(() => {
                setStatePlate('STOP');
                setStateBolw('OPEN');
            }, 3000);
        }
    }, [result]);

    return (
        <>
            <div className={`${styles.plateBowlWrap} ${statePlate === 'XOC' ? 'xoc' : ''}`}>
                {<img className={`bg-timer ${!showTimer ? 'hide' : ''}`} src={require(`assets/images/mini-xd/timer.png`)} alt="" />}
                <div className={`plate-icon ${!showTimer ? 'show' : ''}`}>
                    <img className="plate-img" src={require(`assets/images/mini-xd/dia.png`)} />
                </div>
                <img className={`bowl-img ${stateBowl === 'OPEN' ? 'open' : ''}`} src={require(`assets/images/mini-xd/chen.png`)} />

                <div className={`timer-count ${showTimer ? 'show' : ''}`}>
                    <div ref={timerRef} className={`time-count ${showHotTimer ? 'hot-timer' : ''}`}>
                        {timerCount}
                    </div>
                </div>

                <div className={`timer-finish`} ref={timerFinishRef}>
                    {timerFinish}
                </div>

                <div className={`result-wrap ${!showTimer || timerCount === '' ? 'show' : ''}`}>
                    <div className="dice-list">
                        {currentResult.map((dice, index) => (
                            <img key={index} className="dice-icon" src={require(`assets/images/mini-xd/dice-${dice}.png`)} />
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
}

const styles = {
    plateBowlWrap: css`
        position: relative;
        height: 100%;
        width: 100%;
        z-index: 2;
        &.xoc {
            animation: ${xocPlate} 200ms ease-out infinite;
        }
        .plate-icon {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            opacity: 0;
            &.show {
                opacity: 1;
            }
        }
        .bg-timer {
            &.hide {
                opacity: 0;
            }
        }
        .bowl-img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            padding: 4px;
            z-index: 4;
            transition: 0.25s ease-in;

            &.open {
                transform: translate(40px, -40px);
                opacity: 0;
            }
        }
        .timer-count {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            opacity: 0;
            transition: 0.25s;
            &.show {
                opacity: 1;
            }
            .time-count {
                background: linear-gradient(180deg, rgba(255, 255, 255, 1) 25%, rgba(176, 176, 176, 1) 50%, rgba(255, 255, 255, 1) 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                font-size: 40px;
                font-weight: 700;
                transition: transform 400ms ease-in-out;
            }
            .hot-timer {
                background: linear-gradient(180deg, rgba(255, 222, 150, 1) 25%, rgba(203, 180, 129, 1) 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
            }
        }

        .result-wrap {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            opacity: 0;
            transition: 0.25s;
            z-index: 3;
            &.show {
                opacity: 1;
            }
            .dice-list {
                width: 100%;
                height: 100%;
                position: relative;
                .dice-icon {
                    width: 25px;
                    position: absolute;
                    &:nth-child(1) {
                        left: 15px;
                        top: 18px;
                    }
                    &:nth-child(2) {
                        right: 15px;
                        top: 18px;
                    }
                    &:nth-child(3) {
                        right: 15px;
                        bottom: 18px;
                    }
                    &:nth-child(4) {
                        left: 15px;
                        bottom: 18px;
                    }
                }
            }
        }
        .timer-finish {
            position: absolute;
            bottom: -18px;
            width: 100%;
            text-align: center;
            color: var(--ion-color-success);
            font-weight: 700;
            transition: transform 400ms ease-in-out;
            &.hide {
                opacity: 0;
            }
        }
    `,
};
